module.exports = __webpack_public_path__ + "img/architect.f5bcc879.png";